import { useLang } from "../lib/i18n";
import { commLabel } from "../lib/constants";
import { fmtDateTime } from "../lib/helpers";
import { Empty, StatusBadge } from "./common";

export default function Timeline({ items, kind = "comm", testid }) {
  const { t, lang } = useLang();
  if (!items?.length) return <Empty text={t("Nothing yet", "Nada todavía")} testid={testid} />;
  return (
    <ol className="divide-y divide-slate-100" data-testid={testid}>
      {items.map((x) => (
        <li key={x.id} className="px-4 py-3">
          <div className="flex flex-wrap items-center gap-2 text-xs text-slate-500">
            <span className="mono">{fmtDateTime(x.created_at, lang)}</span>
            {kind === "comm" && <span className="font-semibold text-slate-700 bg-slate-100 rounded px-1.5 py-0.5">{commLabel(x.type, lang)}</span>}
            {kind === "comm" && x.status && x.status !== "logged" && <StatusBadge status={x.status} />}
            <span>· {x.user_name}</span>
          </div>
          <div className="text-sm text-slate-800 mt-1 whitespace-pre-wrap">{kind === "comm" ? (x.subject ? `${x.subject}: ` : "") + x.content : x.action}</div>
        </li>
      ))}
    </ol>
  );
}
